const translations = {
    'production.burner': 'Wypalacz %d',
    'production.blacksmithTargetTools': 'Cel narzędzi kuźni: %d',
    'production.blacksmithTargetWeapons': 'Cel broni kuźni: %d',
    'production.blacksmithInputWood': 'Wejście drewna kuźni',
    'production.blacksmithInputIngots': 'Wejście sztabek kuźni',
    'production.blacksmithInputLeather': 'Wejście skóry kuźni',
    'production.blacksmithOutputTools': 'Kolejka narzędzi kuźni',
    'production.blacksmithOutputWeapons': 'Kolejka broni kuźni',
    'production.campWaiting': 'Drewno w obozie: %d',
    'production.charcoalInput': 'Wejście węgla: %d %s',
    'production.charcoalOutput': 'Wyjście węgla: %d',
    'production.coldDebt': 'Dług zimna: %s',
    'production.farmer': 'Rolnik %d',
    'production.fishStock': 'Zapas ryb: %d/%d',
    'production.fisher': 'Rybak %d',
    'production.foodHours': 'Zapas jedzenia: %s h (wymaga %s h)',
    'production.forestStock': 'Zapas lasu: %d',
    'production.goldMiner': 'Górnik złota %d',
    'production.hunter': 'Myśliwy %d',
    'production.lumberIdle': 'Obóz drwali bezczynny (brak drzew).',
    'production.lumberWork': 'Praca obozu drwali (wiek drzewa %d)',
    'production.mason': 'Ceglarz %d',
    'production.miner': 'Górnik %d',
    'production.minter': 'Mincerz %d',
    'production.noBurners': 'Brak przydzielonych wypalaczy.',
    'production.noFarmers': 'Brak pracujących rolników.',
    'production.noFishers': 'Brak rybaków.',
    'production.noGoldMiners': 'Brak górników złota.',
    'production.noHunters': 'Brak pracujących myśliwych.',
    'production.noMasons': 'Brak przydzielonych ceglarzy.',
    'production.noMiners': 'Brak przydzielonych górników.',
    'production.noMinters': 'Brak mincerzy.',
    'production.noQuarrymen': 'Brak przydzielonych kamieniarzy.',
    'production.noSmelters': 'Brak przydzielonych hutników.',
    'production.noSmiths': 'Brak kowali.',
    'production.noSmokers': 'Brak wędzarzy.',
    'production.noWeavers': 'Brak tkaczy.',
    'production.populationGrowth': 'Wzrost populacji',
    'production.modal.title': '%s / %s',
    'production.modal.progress': 'Postep',
    'production.modal.storage': 'Magazyn wejsc/wyjsc',
    'production.modal.workers': 'Pracownicy',
    'production.modal.inputLine': 'Wejscie %s: %s (limit %s)',
    'production.modal.outputLine': 'Wyjscie %s: %s (limit %s)',
    'production.modal.setInputCap': 'Ustaw limit wejscia (%s)',
    'production.modal.setOutputCap': 'Ustaw limit wyjscia (%s)',
    'production.modal.noCap': 'bez limitu',
    'production.modal.noProgress': 'Brak aktywnych pracownikow.',
    'production.modal.noStorage': 'Brak magazynu dla budynku.',
    'production.quarryman': 'Kamieniarz %d',
    'production.sawmillInput': 'Wejście tartaku: %d %s',
    'production.sawmillOutput': 'Wyjście tartaku: %d %s',
    'production.sawmillWork': 'Praca tartaku (1 %s -> %d %s)',
    'production.storage.title': 'Magazyn wejsc/wyjsc',
    'production.tile.sawmill': 'Tartak',
    'production.tile.charcoal': 'Smolarnia',
    'production.tile.blacksmithTools': 'Kowal (narzedzia)',
    'production.tile.blacksmithWeapons': 'Kowal (bron)',
    'production.tile.inputNone': 'Wejscie: -',
    'production.progress': 'Postep: %d/%d',
    'production.section': 'Produkcja',
    'production.setBlacksmithToolsTarget': 'Ustaw cel narzędzi',
    'production.setBlacksmithWeaponsTarget': 'Ustaw cel broni',
    'production.smelter': 'Hutnik %d',
    'production.smithTool': 'Kowal %d (narzędzia)',
    'production.smithWeapon': 'Kowal %d (broń)',
    'production.smoker': 'Wędzarz %d',
    'production.weaver': 'Tkacz %d',
    'production.wildlife': 'Dzika zwierzyna: %d',
};

export default translations;
